// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdrModalController from "./adr_modal_controller"
application.register("adr-modal", AdrModalController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import BaseRailsRequestController from "./base_rails_request_controller"
application.register("base-rails-request", BaseRailsRequestController)

import BeforeUnloadWarningController from "./before_unload_warning_controller"
application.register("before-unload-warning", BeforeUnloadWarningController)

import CheckboxRequestController from "./checkbox_request_controller"
application.register("checkbox-request", CheckboxRequestController)

import CountrySelectController from "./country_select_controller"
application.register("country-select", CountrySelectController)

import DataFormController from "./data_form_controller"
application.register("data-form", DataFormController)

import DimensionAddressFormController from "./dimension_address_form_controller"
application.register("dimension-address-form", DimensionAddressFormController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import DutchAutocompleteController from "./dutch_autocomplete_controller"
application.register("dutch-autocomplete", DutchAutocompleteController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GoodsSelectController from "./goods_select_controller"
application.register("goods-select", GoodsSelectController)

import InsuranceFormController from "./insurance_form_controller"
application.register("insurance-form", InsuranceFormController)

import LocalityAutocompleteController from "./locality_autocomplete_controller"
application.register("locality-autocomplete", LocalityAutocompleteController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PreferencesCheckboxController from "./preferences_checkbox_controller"
application.register("preferences-checkbox", PreferencesCheckboxController)

import ProviderFormController from "./provider_form_controller"
application.register("provider-form", ProviderFormController)

import RuleFieldsController from "./rule_fields_controller"
application.register("rule-fields", RuleFieldsController)

import RuleGroupFieldsController from "./rule_group_fields_controller"
application.register("rule-group-fields", RuleGroupFieldsController)

import ScrollToErrorController from "./scroll_to_error_controller"
application.register("scroll-to-error", ScrollToErrorController)

import ShipmentItemController from "./shipment_item_controller"
application.register("shipment-item", ShipmentItemController)

import ShipmentItemPreviewerController from "./shipment_item_previewer_controller"
application.register("shipment-item-previewer", ShipmentItemPreviewerController)

import TimeSelectController from "./time_select_controller"
application.register("time-select", TimeSelectController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import ValueOptionFieldsController from "./value_option_fields_controller"
application.register("value-option-fields", ValueOptionFieldsController)
